import React from 'react';
import useTooltip from '@hooks/useTooltip';
import Tooltip from '@components/Tooltip/Tooltip';
const GlobalTooltipProvider: React.FC = () => {
  const {
    tooltipState
  } = useTooltip();
  return <Tooltip isVisible={tooltipState.isVisible} content={tooltipState.content} position={tooltipState.position} targetElement={tooltipState.targetElement} />;
};
export default GlobalTooltipProvider;